import { FileError } from 'react-dropzone'
import { fileuploadErrors } from './constants'

const INVALID_FILE_NAME_CHARS = /[<>:|]/

/**
 * Dropzone `validator`: rejects files whose name contains characters the
 * attachment service cannot store.
 */
export function validateFileName(file: File): FileError | null {
  if (INVALID_FILE_NAME_CHARS.test(file.name)) {
    return {
      code: 'file-name-invalid',
      message: fileuploadErrors.FILE_NAME,
    }
  }
  return null
}
